<template lang="html">
  <div class="container-lg">
    <div class="row">
      <div class="col-sm-12 col-md-4 mt-3"> 
		<div class="card" style="cursor: pointer;"  v-on:click="PushTo('/impressum')">
           <div class="card-body text-center">
				<font-awesome-icon :icon="['fas', 'fa-circle-info']" class="fa-5x" style="color: #198fcf;" />
          	</div>
          <div class="text-center" 
		  	>Impressum</div>
        </div>
      </div>
      <div class="col-sm-12 col-md-4 mt-3" v-on:click="PushTo('/datenschutz')" style="cursor: pointer;">
		<div class="card">
           <div class="card-body text-center">
				<font-awesome-icon :icon="['fas', 'fa-shield-halved']" class="fa-5x" style="color: #198fcf;" />
          	</div>
          	<div class="text-center">
				Datenschutz
			</div>
        </div>
      </div>
    	<div class="col-sm-12 col-md-4 mt-3">
			<div class="card" style="cursor: pointer;" v-on:click="PushTo('/disclaimer')">
           		<div class="card-body text-center">
					<font-awesome-icon :icon="['fas', 'fa-file-lines']" class="fa-5x" style="color: #198fcf;" />
          		</div>
          		<div class="text-center">
		  			Disclaimer
				</div>
     		</div>
      	</div>
		<div class="col-sm-12 col-md-4 mt-3">
			<div class="card" v-on:click="PushTo('/contact')" style="cursor: pointer;">
           		<div class="card-body text-center">
					<font-awesome-icon :icon="['fas', 'fa-phone']" class="fa-5x" style="color: #198fcf;" />
          		</div>
          		<div class="text-center">
		  			Kontakt
				</div>
     		</div>
      	</div>
		<div class="col-sm-12 col-md-4 mt-3">
			<div class="card" style="cursor: pointer;" v-on:click="PushTo('/agb')">
           		<div class="card-body text-center">
					<font-awesome-icon :icon="['fas', 'section']" class="fa-5x" style="color: #198fcf;" />
          		</div>
          		<div class="text-center">
		  			AGB
				</div>
     		</div>
			 <div class="col-sm-12 col-md-4 mt-3">
			<div class="card" style="cursor: pointer;" v-on:click="PushTo('/signedin')">
           		<div class="card-body text-center">
					<font-awesome-icon :icon="['fas', 'up-from-bracket']" class="fa-5x" style="color: #198fcf;" />
          		</div>
          		<div class="text-center">
		  			Zum Hauptmenü
				</div>
     		</div>
      	</div>
      	</div>

    </div>



		




     <div class="row">
      
     </div>
  </div>
</template>


<script>
import axios from 'axios';
export default{
	props:['id'],
	data() {
		return{
			password: null,
		}
	},
	methods:{
		PushTo(route) { // Avoid redundant navigation to current location error - check also main.js router.beforeEach-section
      		try {
        		this.$router.push(route);     
      		} catch (error) {
          		if (!(error instanceof NavigationDuplicated)) {
            	throw error;
          		}          
        	}
    	},
		logout() {
			localStorage.removeItem("user");
			localStorage.removeItem("cognitoToken");
			localStorage.removeItem("company");
			localStorage.removeItem("userType");
			this.isLoggedIn = false;
			this.isUser = null;
			this.isCompany = null;
			this.$router.app.loggedIn = false;
			this.$router.push({
        		name: "home",
        		params: { successMessage: "Du hast dich erfolgreich abgemeldet" },
      		})
     		.catch(err => {
				// Ignore the vuex err regarding  navigating to the page they are already on.
				if (
					err.name !== 'NavigationDuplicated' &&
					!err.message.includes('Avoided redundant navigation to current location')
				) {
					// But print any other errors to the console
				logError(err);
			}
  }); 
    },
	},

	created(){

	},
  watch: {
    '$route'() {
    }
  }
}
</script>